export const styleRules = (width: number) => {
  const isSM = width < 1024

  let controlStyle
  let placeholderStyle

  switch (true) {
    case isSM:
      controlStyle = {
        fontSize: '1rem'
      }
      placeholderStyle = {
        fontSize: '1rem'
      }

      break

    default:
      controlStyle = {
        fontSize: '0.75rem'
      }
      placeholderStyle = {
        fontSize: '0.75rem'
      }
  }
  return {
    controlStyle,
    placeholderStyle
  }
}
